import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof from "@babel/runtime/helpers/esm/typeof";
var _excluded = ["required"];
import _ from 'lodash';
import { CONTAINS, EQ, GT, GTE, IF, LT, LTE, NEQ, NOTCONTAINS, NOTEXISTS, EXISTS, SWITCH } from '../constants';
var operations = function operations(_ref) {
  var op = _ref.op,
    property = _ref.property,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    output = _ref.output;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CONTAINS, (value == null ? void 0 : value.toString().includes(property)) && output), EQ, property === value && output), EXISTS, function () {
    if (_typeof(property) !== 'object' && Boolean(property)) {
      return output || true;
    }
    if (_.isObject(property) && !_.isEmpty(property)) {
      return output || true;
    }
    return false;
  }()), GT, property > value && output), GTE, property >= value && output), LT, property < value && output), LTE, property <= value && output), NEQ, property !== value && output), NOTCONTAINS, !(value == null ? void 0 : value.toString().includes(property)) && output), NOTEXISTS, function () {
    if (_typeof(property) !== 'object' && !property) {
      return output || true;
    }
    if (_.isObject(property) && _.isEmpty(property)) {
      return output || true;
    }
    return false;
  }())[op];
};
var inventory = function inventory(statement, rules) {
  return _defineProperty(_defineProperty({}, IF, function () {
    if (rules.conditionals) {
      var results = rules.conditionals.reduce(function (acc, rule) {
        var operation = operations(_extends({}, rule, {
          output: true
        }));
        acc.push(operation);
        return acc;
      }, []);
      return results.every(Boolean) && rules.output;
    }
    if (Array.isArray(rules)) {
      return rules.reduce(function (acc, _ref2) {
        var _ref2$required = _ref2.required,
          required = _ref2$required === void 0 ? true : _ref2$required,
          rule = _objectWithoutProperties(_ref2, _excluded);
        var operation = operations(rule);
        if (operation || required) {
          acc.push(operation);
        }
        return acc;
      }, []);
    }
    return operations(rules);
  }), SWITCH, function () {
    var result;
    rules.forEach(function (rule) {
      if (!result) {
        var operation = operations(rule);
        if (operation) {
          result = operation;
        }
      }
    });
    return result;
  })[statement];
};
var _parseStatements = function parseStatements() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _.transform(data, function (result, value, key) {
    if (_.isPlainObject(value)) {
      var _Object$keys = Object.keys(value),
        _Object$keys2 = _slicedToArray(_Object$keys, 1),
        statement = _Object$keys2[0];
      var fn = inventory(statement, value[statement]);
      result[key] = fn ? fn() : _parseStatements(value);
    } else {
      result[key] = value;
    }
  });
};
export { inventory, operations };
export default _parseStatements;